



























import { Component, Watch, Mixins } from 'vue-property-decorator'

import { mdiLogout, mdiPhoneOutline, mdiHomeAccount, mdiEye } from '@mdi/js'

import { security } from '@/store/modules/security'
import { settings } from '@/store/modules/settings'
import { support } from '@/store/modules/support'

import { notifications } from '@/store/modules/notifications'
import { Navigator } from '@/mixins/Navigator'

import NotificationBar from '@/components/layouts/app/NotificationBar.vue'
import WithCardsHeader from '@/components/layouts/app/WithCardsHeader.vue'
import WithoutCardsHeader from '@/components/layouts/app/WithoutCardsHeader.vue'
import UnauthorizedHeader from '@/components/layouts/app/UnauthorizedHeader.vue'

import Plain from '@/components/templates/Plain.vue'

import { mock } from '@/tools'

@Component({
  components: {
    NotificationBar,
    WithCardsHeader,
    WithoutCardsHeader,
    UnauthorizedHeader,
    Plain,
  },
})
class AppTemplate extends Mixins<Navigator>(Navigator) {
  securityModule = security.context(this.$store)
  settingsModule = settings.context(this.$store)
  supportModule = support.context(this.$store)

  notificationsModule = notifications.context(this.$store)
  icons = {
    mdiLogout,
    mdiPhoneOutline,
    mdiHomeAccount,
    mdiEye,
  }
  htmlTag = document.documentElement

  get phone() {
    return this.supportModule.state.phone
  }

  get portalLink() {
    return process.env.VUE_APP_PORTAL_LINK
  }

  async created() {
    this.changeFontSize(this.settingsModule.state.mainFontSize)
    await this.supportModule.actions.getPhone().catch(mock)
  }

  @Watch('$theme.isSpecial', { immediate: true })
  saveTheme(isSpecial: boolean) {
    if (!isSpecial) this.settingsModule.mutations.setFontSize('20')
  }

  @Watch('settingsModule.state.mainFontSize')
  changeFontSize(size: string) {
    this.htmlTag.style.fontSize = `${size}px`
  }

  async logout() {
    try {
      await this.notificationsModule.actions.enableCheckNotificationsLoop(false)
      await this.$router.push({ name: 'logout' })
    } catch (error) {
      mock(error)
    }
  }
}

export default AppTemplate
